module.exports = __webpack_public_path__ + "img/Deploy.3a679cdd.png";